import React from 'react';
import Navbar from '../components/Navbar/navbar';
import Footer from '../components/Footer/footer';
import Marquee from '../components/Marquee/marquee';
function Layout({ children }) {
  return (
    <div>
      <Navbar />
      <Marquee />
      {children}
      <Footer />
    </div>
  );
}

export default Layout;
